import React, { useState, useEffect } from 'react';

import { EmptyImage } from '@vlabs/shared/components/empty-image';
import Loader from '@vlabs/shared/legacy-components/loader/Loader';

import st from './VideoAnalyticsImage.module.sass';

interface VideoAnalyticsImageProps {
  imageUrl?: string;
}

export function VideoAnalyticsImage({ imageUrl = undefined }: VideoAnalyticsImageProps): React.JSX.Element {
  const [state, setState] = useState({
    isLoading: !!imageUrl,
    isEmpty: !imageUrl,
  });

  useEffect(() => {
    setState({
      isLoading: !!imageUrl,
      isEmpty: !imageUrl,
    });
  }, [imageUrl]);

  if (state.isEmpty) {
    return <EmptyImage className={st.EmptyImage} />;
  }

  return (
    <div className={st.Root}>
      <div
        className={st.BackgroundImage}
        style={{ backgroundImage: `url(${imageUrl})` }}
      />

      <img
        alt="VideoAnalyticsImage"
        className={st.VideoAnalyticsImage}
        data-testid="workspace.analyticEventCard.image"
        onError={() => {
          setState({
            isLoading: false,
            isEmpty: true,
          });
        }}
        onLoad={() => {
          setState((prev) => ({
            ...prev,
            isLoading: false,
          }));
        }}
        src={imageUrl}
      />

      {!!state.isLoading && (
        <div className={st.Loader}>
          <Loader />
        </div>
      )}
    </div>
  );
}
